import { type ReactNode, useId } from 'react';
import { clsx } from 'clsx';
import styles from './AnalyticalPanel.module.css';

export interface AnalyticalPanelProps {
  title?: string;
  eyebrow?: string;
  subtitle?: string;
  actions?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
  className?: string;
  tone?: 'default' | 'feature' | 'recessed';
}

export function AnalyticalPanel({
  title,
  eyebrow,
  subtitle,
  actions,
  footer,
  children,
  className,
  tone = 'default',
}: AnalyticalPanelProps) {
  const titleId = useId();
  return (
    <section
      className={clsx(
        styles.panel,
        tone === 'feature' && styles.feature,
        tone === 'recessed' && styles.recessed,
        className,
      )}
      aria-labelledby={title ? titleId : undefined}
    >
      {(title || eyebrow || actions) && (
        <header className={styles.header}>
          <div>
            {eyebrow && <span className={styles.eyebrow}>{eyebrow}</span>}
            {title && <h2 id={titleId}>{title}</h2>}
            {subtitle && <p>{subtitle}</p>}
          </div>
          {actions && <div className={styles.actions}>{actions}</div>}
        </header>
      )}
      <div className={styles.body}>{children}</div>
      {footer && <footer className={styles.footer}>{footer}</footer>}
    </section>
  );
}
